<template>
  <div id='paymentresult'>
       <NavTop title='支付结果' :islink='true' linkurl='/index'/>
       <van-empty
        class="custom-image"
        :image="okimg"
        description="支付成功"
        />
  </div>
</template>
<script>
import { Empty } from 'vant';
import NavTop from '@/components/navtop'
import payOK from '@/assets/img/payok.svg'
export default {
   name: 'paymentresult',
   data() {
      return{
         okimg:payOK
      }
   }, 
   components: {
        [Empty.name]:Empty,
        NavTop
   }
}
</script>
<style scoped>
#paymentresult{background-color:#fff;min-height: 100vh;padding-top:60px;z-index:999;}
 .custom-image .van-empty__image {
    width: 1.0rem;
    height: 1.0rem;
  }
::v-deep .van-empty__image{width:1rem;height:1rem;}  
</style>